import { useEffect, useRef } from 'react'

export const useTextareaResize = (text: string, isVisible: boolean) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null)

    useEffect(() => {
        if (textareaRef.current) {
            const resize = () => {
                if (textareaRef.current) {
                    textareaRef.current.style.height = 'auto'
                    textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px'
                }
            }

            if (isVisible) {
                // Resize when textarea becomes visible
                setTimeout(resize, 0)
            } else {
                // Use requestAnimationFrame to ensure DOM is updated
                requestAnimationFrame(resize)
            }
        }
    }, [text, isVisible])

    return textareaRef
}
